module.exports = __webpack_public_path__ + "static/media/c5_new.0172292f.png";